import { useSmartrrVendorSelector } from "@vendor-app/app/_state/typedVendorReduxHooks";

export function useUser() {
  return useSmartrrVendorSelector(state => state.auth.user)!;
}
